var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendationInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "idea-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.08938 14.998C5.71097 14.1474 5.5 13.2011 5.5 12.2039C5.5 8.50038 8.41015 5.49805 12 5.49805C15.5899 5.49805 18.5 8.50038 18.5 12.2039C18.5 13.2011 18.289 14.1474 17.9106 14.998",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 1.99805V2.99805",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22 11.998H21",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3 11.998H2",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.0704 4.92773L18.3633 5.63484",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.6368 5.63484L4.92969 4.92773",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.5175 19.3055C15.5279 18.9786 15.9331 18.0538 16.0471 17.1236C16.0811 16.8458 15.8525 16.6152 15.5725 16.6152L8.47734 16.6154C8.18774 16.6155 7.95516 16.8612 7.98974 17.1488C8.10139 18.0771 8.38319 18.7553 9.45394 19.3055M14.5175 19.3055C14.5175 19.3055 9.6302 19.3055 9.45394 19.3055M14.5175 19.3055C14.396 21.2505 13.8343 22.0207 12.0073 21.9991C10.0531 22.0352 9.60352 21.0831 9.45394 19.3055",
    stroke: "#667185",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationInactive);
export default __webpack_public_path__ + "static/media/recommendation-inactive.1793d3e7941112a311a33db389f39b8b.svg";
export { ForwardRef as ReactComponent };